export { Badge } from './Badge'
export type { BadgeLabelProps, BadgeProps } from './Badge.types'
